import { Tabs } from "antd";

const CustomTabs = ({ activeKey, children, style, onTabChange, ...props }) => {
  return (
    <Tabs
      style={{
        background: "#fff",
        padding: "0 24px 10px",
        borderRadius: "8px",
        boxShadow: " 0 20px 27px rgb(0 0 0 / 5%)",
        ...style,
      }}
      size="large"
      onChange={onTabChange}
      {...props}
    >
      {children}
    </Tabs>
  );
};
export default CustomTabs;
